/**
 * Popover — wrapper sobre Polaris Popover.
 * Visual: idéntica a Polaris Popover hoy.
 * Beneficio: los componentes no importan directamente @shopify/polaris.
 * Migración futura: cambiar solo este archivo.
 */
import { Popover as PolarisPopover, Box } from '@shopify/polaris';
import type { ReactElement, ReactNode } from 'react';
import type { SpaceScale } from '@shopify/polaris-tokens';

interface PopoverProps {
  active: boolean;
  // Polaris clona el activator (cloneElement) para engancharle ref y handlers:
  // debe ser un elemento, no cualquier ReactNode.
  activator: ReactElement;
  onClose: () => void;
  preferredPosition?: 'above' | 'below' | 'mostSpace';
  preferredAlignment?: 'left' | 'center' | 'right';
  autofocusTarget?: 'first-node' | 'container' | 'none';
  children?: ReactNode;
}

export function Popover({
  active,
  activator,
  onClose,
  preferredPosition = 'below',
  preferredAlignment = 'left',
  autofocusTarget = 'first-node',
  children,
}: PopoverProps) {
  return (
    <PolarisPopover
      active={active}
      activator={activator}
      onClose={onClose}
      preferredPosition={preferredPosition}
      preferredAlignment={preferredAlignment}
      autofocusTarget={autofocusTarget}
    >
      {children}
    </PolarisPopover>
  );
}

/**
 * PopoverContent — contenedor estándar para el contenido del Popover.
 * Usa Box de Polaris para mantener el padding y ancho correctos.
 */
interface PopoverContentProps {
  children: ReactNode;
  minWidth?: string;
  maxWidth?: string;
  padding?: SpaceScale;
}

export function PopoverContent({
  children,
  minWidth = '240px',
  maxWidth = '360px',
  padding = '300',
}: PopoverContentProps) {
  return (
    <Box padding={padding} minWidth={minWidth} maxWidth={maxWidth}>
      {children}
    </Box>
  );
}
